<template>
    <div class="bg_main" style="background-color:#f6f1eb !important  ">

        <v-row align="stretch" >
            <v-col cols="12">

                    <List v-if="action === 'list'"/>

                    <Create v-if="action === 'create'"/>
                    
                    <v-container>
                        <Edit v-if="action === 'edit'" />
                    </v-container>
            </v-col>
        </v-row>

    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import List from "../components/Order/List";
    import Create from "../components/Order/Create";
    import Edit from "../components/Order/Edit";
    import {paymentStatusOrderRequest} from "bestgob-core/api/models";

export default {
    name: "Orders",
    components: {
        List, Create, Edit
    },

    data() {
        return {
            action: ''
        }
    },

    created() {
        this.$gtag.event('mis_ordenes', { method: 'Google' }) // Google Analytics
    },

    computed: {
        ...mapState({ordersStore: state => state.orders})
    },

    watch: {
        $route(){
            this.action = this.$route.params.action
        }
    },

    mounted() {
        //Action = list || create || payment_response || edit ||  pay
        this.action = this.$route.params.action

        if (this.action === 'payment_response'){
            this.paymentResponse()
        }
    },

    methods: {
        ...mapActions('orders', ['getPaymentStatusOrder']),

        paymentResponse(){
            // eslint-disable-next-line no-unused-vars
            let orderId = this.$route.params.id
            let request = paymentStatusOrderRequest()
            request.id = orderId

            this.getPaymentStatusOrder(request)
        }

    },
}
</script>

<style scoped>
    .card-orders-list {
        min-height: 85vh;
    }
    

    .v-stepper__step--complete> .v-stepper__label{
        color: #FFFFFF !important;
        margin-right: auto !important;
        margin-left: auto !important;
    }

    .v-stepper__label{
        color: #FFFFFF !important;
        margin-right: auto !important;
        margin-left: auto !important;
    }
</style>